<template>
  <Suspense>
    <div class="h-screen w-full">
      <SearchBarVue
        v-if="rbac_store.isFeatureFlagEnabled('SIDEBAR_FLOWBITE')"
        :show-icon="false"
      />
      <router-view />
    </div>
  </Suspense>
</template>

<script setup>
import { useIdle } from '@vueuse/core';
import { useJwt } from '@vueuse/integrations/useJwt';
import { clearTokens } from './utils/auth';
import { watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import SearchBarVue from './components/SearchBar.vue';
import { useUsersStore } from '@/stores/useUsers';
import { useMetrics } from '@/stores/useMetrics';
import { useWebSockets } from '@/stores/useWebSockets';
import { getUserInitials } from './utils/helpers';
import { useRbacStore } from './stores/useRbac';

const users_store = useUsersStore();
const rbac_store = useRbacStore();
const metrics_store = useMetrics();
const websocket_Store = useWebSockets();
const route = useRoute();

const TIMEOUT = process.env.VUE_APP_AUTH_TIMEOUT || 30;

const { idle } = useIdle(TIMEOUT * 60 * 1000);

onMounted(async () => {
  await handlePageRefresh();
});

// Initial login
watch(route, async route => {
  if (route?.redirectedFrom?.path === '/status') {
    await handlePageRefresh();
    users_store.authActivity('login');
  }
});

watch(
  () => idle.value,
  () => {
    if (idle.value == true) {
      users_store.logOut();
    }
  }
);

async function handlePageRefresh() {
  const id_token = sessionStorage.getItem('id_token');
  if (!id_token || id_token == 'undefined') return;

  const { payload } = useJwt(id_token);

  //Pulling user id from token and giving it to the user store for UI processes
  users_store.activeUser = { auxo_user_id: payload.value.auxo_user_id };
  const user = await users_store.getUserByEmail(payload.value.email);

  if (!user) {
    clearTokens();
    return router.push('/login');
  }

  // Load user
  users_store.activeUser = {
    ...payload.value,
    initials: getUserInitials(user),
    username: user.username,
    auxo_user_id: user.auxo_user_id,
    photo_url: user.photo_url || 'none',
    is_active: user.is_active,
  };

  // Load metrics
  metrics_store.activeUserID = user.auxo_user_id;
  metrics_store.activeUsername = user.username;
  metrics_store.activeUserDailyComplete = 0;
  await metrics_store.getUserMetrics();

  // All Users are loaded so the router guard can validate
  // a user exists by looking up their auxo_user_id
  if (!users_store.isLoading) {
    users_store.isLoading = true;
    await users_store.getAllUsers();
    users_store.isLoading = false;
  }

  try {
    websocket_Store.connect();
  } catch (error) {
    console.error('WebSocket connection failed:', error);
  }
}
</script>
